export const MESSAGE = {
  ERROR: {
    title: '잠시 후 다시 시도해주세요',
    description: '일시적으로 오류가 발생했습니다. ',
    confirmBtnText: '확인',
    renderCancelBtn: false,
  },
  BONUS: {
    title: '이동 지원금이 신청 되었어요!',
    description:
      '3만 크레딧이 지급될 예정이에요. 알림을 통해 지급된 크레딧을 확인할 수 있어요.',
    imgType: 'credit',
    confirmBtnText: '추가지원금 받으러 가기',
  },
  NEED_LICENSE: {
    title: '이동지원금 대상자예요!',
    description: '면허만 등록하면 10,000크레딧을 드려요.',
    confirmBtnText: '면허 등록하기',
  },
  NOT_ELIGIBLE_WITH_LICENSE: {
    title: '아쉽게도 대상자가 아니에요',
    description: '하지만 추가지원금이 남아 있어요.\n추가지원금에 도전해보세요!',
    confirmBtnText: '추가지원금 받으러 가기',
  },
  NOT_ELIGIBLE_WITHOUT_LICENSE: {
    title: '아쉽게도 대상자가 아니에요',
    description:
      '하지만 추가지원금이 남아 있어요.\n면허 등록 후, 추가지원금에 도전해보세요!',
    confirmBtnText: '면허 등록하기',
  },
  NEED_PASSPORT_WINBACK: {
    title: '이동지원금 대상자예요!',
    description: '패스포트 무료 구독하면\n10,000크레딧을 드려요.',
    confirmBtnText: '패스포트 무료 가입',
  },
  NEED_PASSPORT_ACTIVE: {
    title: '아쉽게도 대상자가 아니에요',
    description:
      '하지만 추가지원금이 남아 있어요.\n패스포트 멤버십 가입 후,\n추가지원금에 도전해보세요!',
    confirmBtnText: '패스포트 멤버십 혜택 보기',
  },
}
